module.exports = __webpack_public_path__ + "img/avatar.ede08b3.svg?v=1762502055057";